import React, {useEffect, useState} from "react";


const HorizontalVector = ({children, ...props}) => {
    const [number, setNumber] = useState(0); // State for the number
    useEffect(() => {
        setNumber(0)
        const interval = setInterval(() => {
            setNumber(prevNumber => {
                if (prevNumber < props["percent"]) {
                    return prevNumber + 1; // Increment number from 1 to 100
                } else {
                    clearInterval(interval); // Stop the interval when number reaches 100
                    return props["percent"]; // Return the current number as 100
                }
            });
        }, 5);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [props["percent"]]); // Run only on component mount

    return (
        <span className="h-full rounded-[min(0.5vw,1vh)] bg-[#00C844]"
              style={{
                  width: `${number}%`,
                  backgroundColor: `${props["percent"] > 66 ? "#00C844" : props["percent"] > 33 ? "#FFB648" : "#FF757C"}`
              }}></span>
    );
};

export default HorizontalVector;